import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}visa-package-order`;

// ✅ Create a new visa package order
export function createVisaPackageOrder(data) {
  return http.post(apiUrl, data);
}

// ✅ Get all visa package orders
export function getAllVisaPackageOrders(params) {
  return http.get(apiUrl, { params });
}

// ✅ Get a specific visa package order by ID
export function getVisaPackageOrderById(id) {
  return http.get(`${apiUrl}/${id}`);
}

export function getCountVisaStatus(params) {
  return http.get(`${apiUrl}/status-count`, { params });
}

// ✅ Update a visa package order by ID
export function updateVisaPackageOrder(id, data) {
  return http.patch(`${apiUrl}/${id}`, data);
}

// ✅ Delete a visa package passenger by ID
export function deleteVisaPackagePassenger(id) {
  return http.delete(`${apiUrl}/passenger/${id}`);
}


// ✅ Delete a visa package order by ID
export function deleteVisaPackageOrder(id) {
  return http.delete(`${apiUrl}/${id}`);
}

// ✅ Delete a passenger document by ID
export function deleteVisaPackagePassengerDocument(id) {
  return http.delete(`${apiUrl}/passenger-document/${id}`);
}

// ✅ Delete a passenger additional service by ID
export function deleteVisaPackagePassengerAdditionalService(id) {
  return http.delete(`${apiUrl}/passenger-additional-service/${id}`);
}

// ✅ Upload passenger document (common endpoint, no ID)
export function uploadPassengerDocument(formData) {
  return http.post(`${apiUrl}/upload-passenger-document`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// ✅ Upload visa document with passenger ID
export async function uploadVisaPackageAttachment(
  visaOrderPassengerId,
  formData
) {
  return http.post(
    `${apiUrl}/upload-visa-document/${visaOrderPassengerId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
